import axios from 'axios';
import {
  MDBBtn,
  MDBBtnGroup,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCarousel,
  MDBCarouselCaption,
  MDBCarouselItem,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBRow,
  MDBTextArea,
  MDBTooltip
} from 'mdb-react-ui-kit';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { UserProfileContext } from '../context/UserProfileProvider';
import DemoSearch from './DemoSearch';
import FieldGroup from './FieldGroup';

import Upload from '../reusables/Upload';
import { FeatureList } from './FeatureList';

const Builder = () => {


    const [formData, setFormData] = useState({
        demoUser: { firstName: '', lastName: '', email: '', commonName: '', phone: '', webSiteUrl: '', companyName: '', imageUrl: '', role:'' },
        mainMessages:[''],
        uid: "",  
        prep: [],
        check: [],
        agenda: [],
        name:'',
        prepValue: '',
    checkValue:'',
     agendaValue:'',

        orchestration: [{
          id:uuidv4(),
            name: '',
            videoUrl: "",
            description: '',
            descriptions: ['aaa'],
            paragrapDescriptions:[{ id:uuidv4(),textValue: 'Default', heading: { textValue: '', textColor: '', textSize: 'h4',fontSize:'fs-3', image:'' ,type:'caption' }, textColor: '', textSize: 'h1',fontSize:'fs-6', type: 'caption' ,'orderNumber':1,paragraphs:[]}],
            imageUrl: 'https://mdbootstrap.com/img/Photos/Slides/img%20(23).jpg',
            imageType: 'image',
            imageUrls: ["https://mdbootstrap.com/img/Photos/Slides/img%20(23).jpg"],
            painPromise: [{ id: uuidv4(), pain: {id: uuidv4(), textValue: '', orderNumber: 1, paragraphs: [], heading: {} }, promise: { id: uuidv4(),textValue: '', orderNumber: 1, paragraphs: [], heading: {} } }],
            feedbacks: [{
                feedbackUser: { firstName: '', lastName: '', email: '', commonName: '', phone: '', webSiteUrl: '', companyName: '', imageUrl: '', role:'' },
                impactsOnYourBusiness: [],
                doesThisSolveTheProblem: false,
                doYouSeeYourSelfUsingIt: false,
                questions: [           
                ],
                checkboxes: [
                  { label: 'Does this solve the problem?', checked: false },
                  { label: 'Do you see yourself using it?', checked: false }
              ],
              isNew: true            
            }],
            subFeatures: []  
        }],
       
     review: [],
     close: [],
     followUp: [],
     reviewValue:'',
     closeValue: '',
followValue:'',
  familyPictures:[]
    });
    const [initialName, setInitialName] = useState(formData.demoUser?.companyName);
    const { tokenLoaded } = useContext(UserProfileContext);
    const refreshCompanyList = useRef(() => { });   
    const [isEdit, setIsEdit] = useState(false);
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;   
    const [isOpen, setIsOpen] = useState(false);
    const [activeAccordions, setActiveAccordions] = useState({});
    const [showCarousel, setShowCarousel] = useState(false); // Toggle for showing/hiding carousel
    const [newUrl, setNewUrl] = useState('');
    const [newCaption, setNewCaption] = useState('');
    const [centredModal, setCentredModal] = useState(false); // Modal state
    const [selectedFeature, setSelectedFeature] = useState(null); // Track the selected feature for the modal
    const [activeFeatureIndex, setActiveFeatureIndex] = useState(null);
    let isAddingFeature = false; // A flag to prevent duplicate clicks
    // Function to add a new family picture URL and caption
    const addFamilyPicture = () => {
      setFormData((prevState) => ({
          ...prevState,
          familyPictures: [
              ...(Array.isArray(prevState.familyPictures) ? prevState.familyPictures : []), // Ensure it's an array
              { url: newUrl, caption: newCaption }
          ]
      }));
      setNewUrl('');  // Clear the input after adding
      setNewCaption('');
  };
  
  const removeFamilyPicture = (index) => {
    setFormData((prevState) => ({
        ...prevState,
        familyPictures: prevState.familyPictures?.filter((_, i) => i !== index)
    }));
};

const handlePictureChange = (index, field, value) => {
    const updatedPictures = formData.familyPictures?.map((picture, i) => {
        if (i === index) {
            return { ...picture, [field]: value }; // Update the specific field
        }
        return picture;
    }) || [];
    setFormData((prevState) => ({ ...prevState, familyPictures: updatedPictures }));
};


  const addMainMessage = () => {
    setFormData((prevState) => ({
        ...prevState,
        mainMessages: [...(prevState.mainMessages || []), ''] // Safely add a new empty message
    }));
};


  const removeMainMessage = (index) => {
      setFormData((prevState) => ({
          ...prevState,
          mainMessages: prevState.mainMessages.filter((_, i) => i !== index) // Remove the message by index
      }));
  };

  const addQuestion = (featurePath, feedbackIndex) => {
    setFormData((prevState) => {
      const updatedOrchestration = [...prevState.orchestration];
      const targetFeature = getFeatureByPath(updatedOrchestration, featurePath);
  
      if (targetFeature && targetFeature.feedbacks) {
        const newFeedbacks = targetFeature.feedbacks.map((feedback, j) => {
          if (j === feedbackIndex) {
            const newQuestions = [
              ...(feedback.questions || []),
              {id:uuidv4(), question: '', answer: '',category: '', isNew: true }
            ];
            return { ...feedback, questions: newQuestions };
          }
          return feedback;
        });
  
        targetFeature.feedbacks = newFeedbacks;
      }
  
      return { ...prevState, orchestration: updatedOrchestration };
    });
  };
  
  const removeQuestion = (featurePath, feedbackIndex, questionIndex) => {
    setFormData((prevState) => {
      const updatedOrchestration = [...prevState.orchestration];
      const targetFeature = getFeatureByPath(updatedOrchestration, featurePath);
  
      if (targetFeature && targetFeature.feedbacks) {
        const updatedFeedbacks = targetFeature.feedbacks.map((feedback, j) => {
          if (j === feedbackIndex) {
            const updatedQuestions = feedback.questions.filter((_, qIndex) => qIndex !== questionIndex);
            return { ...feedback, questions: updatedQuestions };
          }
          return feedback;
        });
  
        targetFeature.feedbacks = updatedFeedbacks;
      }
  
      return { ...prevState, orchestration: updatedOrchestration };
    });
  };
  const handleQuestionInputChange = (featureIndex, feedbackIndex, questionIndex, key, value) => {
    setFormData((prevState) => {
        // Create a deep copy of the state
        const updatedOrchestration = [...prevState.orchestration];

        // Get the target feature, feedback, and question
       // const feature = updatedOrchestration[featureIndex];
        const feature = getFeatureByPath(updatedOrchestration, featureIndex);
        if (!feature || !feature.feedbacks || !feature.feedbacks[feedbackIndex]) {
            console.error("Invalid feature or feedback index");
            return prevState;
        }

        const feedback = feature.feedbacks[feedbackIndex];
        if (!feedback.questions || !feedback.questions[questionIndex]) {
            console.error("Invalid question index");
            return prevState;
        }

        // Update the specified key (e.g., 'question', 'answer') with the new value
        feedback.questions[questionIndex][key] = value;

        // Return the updated state
        return { ...prevState, orchestration: updatedOrchestration };
    });
};


const handleAnswerInputChange = (featureIndex, feedbackIndex, questionIndex, value) => {
    setFormData((prevState) => {
        // Create a deep copy of the state
        const updatedOrchestration = [...prevState.orchestration];

        // Get the target feature and feedback
        const feature = getFeatureByPath(updatedOrchestration, featureIndex);
        if (!feature || !feature.feedbacks || !feature.feedbacks[feedbackIndex]) {
            console.error("Invalid feature or feedback index");
            return prevState;
        }

        const feedback = feature.feedbacks[feedbackIndex];
        if (!feedback.questions || !feedback.questions[questionIndex]) {
            console.error("Invalid question index");
            return prevState;
        }

        // Update the answer field for the specific question
        feedback.questions[questionIndex].answer = value;
        

        // Return the updated state
        return { ...prevState, orchestration: updatedOrchestration };
    });
};

  
  const addCheckbox = (featurePath, feedbackIndex) => {
    setFormData((prevState) => {
      const updatedOrchestration = [...prevState.orchestration];
      const targetFeature = getFeatureByPath(updatedOrchestration, featurePath);
  
      if (targetFeature && targetFeature.feedbacks) {
        const updatedFeedbacks = targetFeature.feedbacks.map((feedback, j) => {
          if (j === feedbackIndex) {
            const checkboxes = feedback.checkboxes || [];
            const newCheckboxes = [
              ...checkboxes,
              { label: `Custom Checkbox ${checkboxes.length + 1}`, checked: false }
            ];
            return { ...feedback, checkboxes: newCheckboxes };
          }
          return feedback;
        });
  
        targetFeature.feedbacks = updatedFeedbacks;
      }
  
      return { ...prevState, orchestration: updatedOrchestration };
    });
  };
  
  const removeCheckbox = (featurePath, feedbackIndex, checkboxIndex) => {
    setFormData((prevState) => {
      const updatedOrchestration = [...prevState.orchestration];
      const targetFeature = getFeatureByPath(updatedOrchestration, featurePath);
  
      if (targetFeature && targetFeature.feedbacks) {
        const updatedFeedbacks = targetFeature.feedbacks.map((feedback, j) => {
          if (j === feedbackIndex) {
            const updatedCheckboxes = feedback.checkboxes.filter((_, k) => k !== checkboxIndex);
            return { ...feedback, checkboxes: updatedCheckboxes };
          }
          return feedback;
        });
  
        targetFeature.feedbacks = updatedFeedbacks;
      }
  
      return { ...prevState, orchestration: updatedOrchestration };
    });
  };
  
  const handleCheckboxChange = (featurePath, feedbackIndex, checkboxIndex, checked) => {
    setFormData((prevState) => {
      const updatedOrchestration = [...prevState.orchestration];
      const targetFeature = getFeatureByPath(updatedOrchestration, featurePath);
  
      if (targetFeature && targetFeature.feedbacks) {
        const updatedFeedbacks = targetFeature.feedbacks.map((feedback, j) => {
          if (j === feedbackIndex) {
            const updatedCheckboxes = feedback.checkboxes.map((checkbox, k) => {
              if (k === checkboxIndex) {
                return { ...checkbox, checked: checked };
              }
              return checkbox;
            });
            return { ...feedback, checkboxes: updatedCheckboxes };
          }
          return feedback;
        });
  
        targetFeature.feedbacks = updatedFeedbacks;
      }
  
      return { ...prevState, orchestration: updatedOrchestration };
    });
  };
  
  const handleCheckboxLabelChange = (featurePath, feedbackIndex, checkboxIndex, newLabel) => {
    setFormData((prevState) => {
      const updatedOrchestration = [...prevState.orchestration];
      const targetFeature = getFeatureByPath(updatedOrchestration, featurePath);
  
      if (targetFeature && targetFeature.feedbacks) {
        const updatedFeedbacks = targetFeature.feedbacks.map((feedback, j) => {
          if (j === feedbackIndex) {
            const updatedCheckboxes = feedback.checkboxes.map((checkbox, k) => {
              if (k === checkboxIndex) {
                return { ...checkbox, label: newLabel };
              }
              return checkbox;
            });
            return { ...feedback, checkboxes: updatedCheckboxes };
          }
          return feedback;
        });
  
        targetFeature.feedbacks = updatedFeedbacks;
      }
  
      return { ...prevState, orchestration: updatedOrchestration };
    });
  };
  
 const newFeedback = {
  feedbackUser: {
    firstName: formData.demoUser?.firstName || '',
    lastName: formData.demoUser?.lastName || '',
    email: formData.demoUser?.email || '',
    commonName: formData.demoUser?.commonName || '',
    phone: formData.demoUser?.phone || '',
    webSiteUrl: formData.demoUser?.webSiteUrl || '',
    companyName: formData.demoUser?.companyName || ''
  },
  impactsOnYourBusiness: [''],
  doesThisSolveTheProblem: false,
  doYouSeeYourSelfUsingIt: false,
  questions: [
    {
      question: '', 
      answer: '', 
      booleanAnswer: false, 
      bgColor: 'white', 
      textColor: 'white', 
      blockquote: '', 
      imageUrl: '' 
    }
  ],
  isNew: true // Mark this feedback as newly added
};   
  
    const showAlert = () => {
        setIsOpen(true);
        setTimeout(() => {
          setIsOpen(false);
        }, 3000); // Auto-hide after 3 seconds
      };
    
    useEffect(() => {
      clearFields();
        const fetchDataDemo = async () => {
            try {
                const response = await axios.get(`${baseUrl}/demo`);
                const sortedData = {
                    ...response.data,
                    orchestration: response.data.orchestration.sort((a, b) => a.slideNumber - b.slideNumber).map(feature => ({
                        ...feature,
                        feedbacks: feature.feedbacks || newFeedback
                    }))
                };
                setFormData(sortedData);
   setInitialName(sortedData?.demoUser?.companyName);

                if (!tokenLoaded) {
                    setFormData((prevState) => ({
                        ...prevState,
                       // demoUser: { firstName: '', lastName: '', email: '', companyName: '', phone: '', webSiteUrl: '', role: '' },
                    }));
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchDataDemo();
    }, []);

    const handleFeedbackUserChange = (key, value, featurePath, feedbackIndex) => {
      setFormData((prevState) => {
        const updatedOrchestration = [...prevState.orchestration];
        
        // Get the feature or sub-feature based on the featurePath
        const targetFeature = getFeatureByPath(updatedOrchestration, featurePath);
    
        if (targetFeature && targetFeature.feedbacks) {
          const updatedFeedbacks = targetFeature.feedbacks.map((feedback, j) => {
            if (j === feedbackIndex) {
              return {
                ...feedback,
                feedbackUser: {
                  ...feedback.feedbackUser,
                  [key]: value,
                },
              };
            }
            return feedback;
          });
    
          // Update the feedbacks in the target feature
          targetFeature.feedbacks = updatedFeedbacks;
        }
    
        // Return the updated form data
        return { ...prevState, orchestration: updatedOrchestration };
      });
    };
    

    const handleDemoUserChange = (key, value) => {
        setFormData((prevState) => ({
            ...prevState,
            demoUser: {
                ...prevState.demoUser,
                [key]: value,
            },
        }));
   };

 
const handleChange = (indexPath = null, feedbackIndex = null, impactIndex = null, key, value) => {
  setFormData((prevState) => {
    // If indexPath is null, update the top-level property
    if (indexPath === null) {
      return { ...prevState, [key]: value };
    }

    // Create a deep copy of orchestration to maintain immutability
    const updatedOrchestration = JSON.parse(JSON.stringify(prevState.orchestration));

    // Check if indexPath is a number or a string
    if (typeof indexPath === 'number' || (typeof indexPath === 'string' && !indexPath.includes('-'))) {
      const featureIndex = parseInt(indexPath, 10);

      if (feedbackIndex !== null && impactIndex !== null) {
        // Impact-level update (array of strings)
        const updatedFeature = { ...updatedOrchestration[featureIndex] };
        const updatedFeedbacks = updatedFeature.feedbacks.map((feedback, idx) => {
          if (idx === feedbackIndex) {
            // Update the impact string at the specific index
            const updatedImpacts = feedback.impactsOnYourBusiness.map((impact, k) =>
              k === impactIndex ? value : impact
            );
            return { ...feedback, impactsOnYourBusiness: updatedImpacts };
          }
          return feedback;
        });
        updatedOrchestration[featureIndex] = { ...updatedFeature, feedbacks: updatedFeedbacks };
      } else if (feedbackIndex !== null) {
        // Feedback-level update
        const updatedFeature = { ...updatedOrchestration[featureIndex] };
        const updatedFeedbacks = updatedFeature.feedbacks.map((feedback, idx) => {
          if (idx === feedbackIndex) {
            return { ...feedback, [key]: value };
          }
          return feedback;
        });
        updatedOrchestration[featureIndex] = { ...updatedFeature, feedbacks: updatedFeedbacks };
      } else {
        // Feature-level update
        updatedOrchestration[featureIndex] = { ...updatedOrchestration[featureIndex], [key]: value };
      }

    } else if (typeof indexPath === 'string' && indexPath.includes('-')) {
      // Handle sub-feature updates
      const path = indexPath.split('-').map((idx) => parseInt(idx, 10));
      let targetFeature = updatedOrchestration[path[0]];

      // Traverse sub-features using the path
      for (let i = 1; i < path.length; i++) {
        targetFeature = targetFeature.subFeatures[path[i]];
      }

      if (feedbackIndex !== null && impactIndex !== null) {
        // Impact-level update for sub-features
        const updatedFeedbacks = targetFeature.feedbacks.map((feedback, idx) => {
          if (idx === feedbackIndex) {
            const updatedImpacts = feedback.impactsOnYourBusiness.map((impact, k) =>
              k === impactIndex ? value : impact
            );
            return { ...feedback, impactsOnYourBusiness: updatedImpacts };
          }
          return feedback;
        });
        targetFeature.feedbacks = updatedFeedbacks;
      } else if (feedbackIndex !== null) {
        // Feedback-level update for sub-features
        const updatedFeedbacks = targetFeature.feedbacks.map((feedback, idx) => {
          if (idx === feedbackIndex) {
            return { ...feedback, [key]: value };
          }
          return feedback;
        });
        targetFeature.feedbacks = updatedFeedbacks;
      } else {
        // Sub-feature-level update
        targetFeature[key] = value;
      }
    } else {
      console.error("Invalid indexPath type:", indexPath);
      return prevState;
    }

    // Return the updated formData with modified orchestration
    return { ...prevState, orchestration: updatedOrchestration };
  });
};

  
  
  
   
    const addItem = (field) => {
        setFormData((prevState) => ({
            ...prevState,
            [field]: [...(prevState[field] || []), '']
        }));
    };
    const removeItem = (field, index) => {
      setFormData((prevState) => ({
          ...prevState,
          [field]: prevState[field].filter((_, i) => i !== index)
      }));
  };

  const addImpact = (featurePath, feedbackIndex) => {
    setFormData((prevState) => {
      const updatedOrchestration = [...prevState.orchestration];
  
      // Get the target feature (main or sub-feature) by its path
      const targetFeature = getFeatureByPath(updatedOrchestration, featurePath);
  
      if (!targetFeature) {
        console.error("Feature not found for path:", featurePath);
        return prevState;
      }
  
      // Add a new empty impact to the impactsOnYourBusiness array in the feedback
      const updatedFeedbacks = targetFeature.feedbacks.map((feedback, j) => {
        if (j === feedbackIndex) {
          return {
            ...feedback,
            impactsOnYourBusiness: [...(feedback.impactsOnYourBusiness || []), '']
          };
        }
        return feedback;
      });
  
      targetFeature.feedbacks = updatedFeedbacks;
  
      return { ...prevState, orchestration: updatedOrchestration };
    });
  };
  const removeImpact = (featurePath, feedbackIndex, impactIndex) => {
    setFormData((prevState) => {
      const updatedOrchestration = [...prevState.orchestration];
  
      // Get the target feature (main or sub-feature) by its path
      const targetFeature = getFeatureByPath(updatedOrchestration, featurePath);
  
      if (!targetFeature) {
        console.error("Feature not found for path:", featurePath);
        return prevState;
      }
  
      // Remove the impact from the impactsOnYourBusiness array
      const updatedFeedbacks = targetFeature.feedbacks.map((feedback, j) => {
        if (j === feedbackIndex) {
          return {
            ...feedback,
            impactsOnYourBusiness: feedback.impactsOnYourBusiness.filter((_, k) => k !== impactIndex)
          };
        }
        return feedback;
      });
  
      targetFeature.feedbacks = updatedFeedbacks;
  
      return { ...prevState, orchestration: updatedOrchestration };
    });
  };
  
    const addSubFeature = (featureId) => {
      setFormData((prevState) => {
        const newOrchestration = (prevState.orchestration || []).map((feature) => {
          if (feature.id === featureId) {
            return {
              ...feature,
              subFeatures: [
                ...(feature.subFeatures || []),
                {
                  id: uuidv4(),
                  slideNumber:feature?.subFeatures?.length+1 || 1,
                  name: '',
                  description: '',
                  paragrapDescriptions:[{ id:uuidv4(),textValue: 'Default', heading: { textValue: '', textColor: '', textSize: 'h3',fontSize:'fs-4', image:''  }, textColor: '', textSize: 'h5',fontSize:'fs-6', type: '' ,'orderNumber':'',paragraphs:[]}],
                  imageUrl: '',
                  imageUrls: [""],
                  imageType: 'image',
                  painPromise: [{ id: uuidv4(), pain: {id: uuidv4(), textValue: '', orderNumber: 1, paragraphs: [], heading: {} }, promise: { id: uuidv4(),textValue: '', orderNumber: 1, paragraphs: [], heading: {} } }],
                  feedbacks: [
                    {
                      feedbackUser: { firstName: '', lastName: '', role: '', email: '', phone: '' },
                      impactsOnYourBusiness: [''],
                      checkboxes: [{ label: '', checked: false }],
                      questions: [{ question: '', answer: '' }],
                    },
                  ],
                },
              ],
            };
          }
          return feature;
        });
        return { ...prevState, orchestration: newOrchestration };
      });
    };
    const addFeature = () => {
      if (isAddingFeature) return; // Prevent duplicate execution
    
      isAddingFeature = true; // Set the flag
      console.log("addFeature called"); // To verify single execution
    
      setFormData((prevState) => ({
        ...prevState,
        orchestration: [
          ...(prevState.orchestration || []), // Ensure orchestration is an array
          {
            id: uuidv4(),
            slideNumber:prevState.orchestration.length+1 || 1,
            name: '',
            videoUrl: "",
            description: '',
            descriptions: [],
            paragrapDescriptions:[{ id:uuidv4(),textValue: 'Default', heading: { textValue: '', textColor: '', textSize: 'h3',fontSize:'fs-4', image:''  }, textColor: '', textSize: 'h5',fontSize:'fs-6', type: '' ,'orderNumber':1,paragraphs:[]}],
            imageUrl: '',
            imageUrls: [""],
            imageType: "image",
            painPromise: [{ id: uuidv4(), pain: {id: uuidv4(), textValue: '', orderNumber: 1, paragraphs: [], heading: {} }, promise: { id: uuidv4(),textValue: '', orderNumber: 1, paragraphs: [], heading: {} } }],
            subFeatures: [],
            feedbacks: [newFeedback],
          },
        ],
      }));
    
      // Reset the flag after a slight delay to allow for further clicks if necessary
      setTimeout(() => {
        isAddingFeature = false;
      }, 300); // Adjust timeout as needed
    };
        
const removeSubFeature = (featureIndex, subIndex) => {
  setFormData((prevState) => {
    const newOrchestration = prevState.orchestration.map((feature, index) => {
      if (index === featureIndex) {
        const updatedSubFeatures = feature.subFeatures.filter((_, subIdx) => subIdx !== subIndex);
        return { ...feature, subFeatures: updatedSubFeatures };
      }
      return feature;
    });
    return { ...prevState, orchestration: newOrchestration };
  });
};

  
    const removeFeature = (index) => {
        setFormData((prevState) => {
            const newOrchestration = prevState.orchestration.filter((_, i) => i !== index);
            return {
                ...prevState,
                orchestration: newOrchestration,
            };
        });
    };
    const addPainPromise = (indexPath) => {
      setFormData((prevState) => {
        const updatedOrchestration = [...prevState.orchestration];
        
        // Ensure indexPath is a string before splitting
        const path = typeof indexPath === 'string' ? indexPath.split('-').map((i) => parseInt(i, 10)) : [indexPath];
        
        let targetFeature = updatedOrchestration[path[0]];
    
        // Traverse sub-features using the path for deeper nested features
        for (let i = 1; i < path.length; i++) {
          targetFeature = targetFeature.subFeatures[path[i]];
        }
    
        const newPainPromise = {
          id: uuidv4(),
          pain: {
            id: uuidv4(),
            textValue: '',
            orderNumber: 1,
            paragraphs: [],
            heading: { textValue: '', textColor: '', textSize: 'h4', fontSize: 'fs-4', image: '' },
            textColor: '',
            textSize: 'h1',
            fontSize: 'fs-4',
            type: '',
          },
          promise: {
            id: uuidv4(),
            textValue: '',
            orderNumber: 1,
            paragraphs: [],
            heading: { textValue: '', textColor: '', textSize: 'h4', fontSize: 'fs-4', image: '' },
            textColor: '',
            textSize: 'h1',
            fontSize: 'fs-4',
            type: '',
          },
        };
    
        targetFeature.painPromise = [...(targetFeature.painPromise || []), newPainPromise];
    
        return { ...prevState, orchestration: updatedOrchestration };
      });
    };
    
    const removePainPromise = (indexPath, painPromiseId) => {
      setFormData((prevState) => {
        const updatedOrchestration = [...prevState.orchestration];
        const targetFeature = getFeatureByPath(updatedOrchestration, indexPath);
    
        // Remove the pain promise by id
        targetFeature.painPromise = targetFeature.painPromise.filter((item) => item.id !== painPromiseId);
    
        return { ...prevState, orchestration: updatedOrchestration };
      });
    };
    
    const handlePainPromiseChange = (indexPath, painPromiseId, field, value) => {
      setFormData((prevState) => {
        const updatedOrchestration = [...prevState.orchestration];
        const targetFeature = getFeatureByPath(updatedOrchestration, indexPath);
        
        // Find the specific PainPromise and update the field
        targetFeature.painPromise = targetFeature.painPromise.map(p => {
          if (p.id === painPromiseId) {
            return {
              ...p,
              [field]: { ...p[field], textValue: value } // Update either pain or promise
            };
          }
          return p;
        });
        
        return { ...prevState, orchestration: updatedOrchestration };
      });
    };
            
 
    const handleCloseModal = () => {
      setCentredModal(false);
      setSelectedFeature(null); // Reset selected feature when modal closes
      setActiveFeatureIndex(null);
    };
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Prevent multiple submissions
        if (isSubmitting) return;
    
        setIsSubmitting(true);
    
        if (!formData.demoUser.companyName || formData.demoUser.companyName.trim() === '') {
            console.error(' Name must not be null or empty');   
       
          
            alert(' Name of the form or demo or classe is required.');
            setIsSubmitting(false);
            return;
        }
    
        const payload = {
            ...formData,
            type: 'demo',
        };
    
        try {
            let response;
            if (formData.id) {
                response = await axios.put(`${baseUrl}/demo/${formData.id}`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
            } else {
                response = await axios.post(`${baseUrl}/demo`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
            }
    
            if (response && response.data) {
                setFormData(response.data);
                refreshCompanyList.current();
            }
            showAlert();
        } catch (error) {
            console.error('There was an error submitting the form!', error);
        } finally {
            setIsSubmitting(false); // Re-enable the button after the operation is complete
        }
    };
    
   
    
    const handleDelete = async () => {
        try {
            if (formData.id) {
                await axios.delete(`${baseUrl}/demo/${formData.id}`);
                clearFields();
                refreshCompanyList.current();
            }
            showAlert();
        } catch (error) {
            console.error('There was an error deleting the data!', error);
        }
    };

    const clearFields = useCallback(async () => {
        try {
            setFormData(formData);
            refreshCompanyList.current();
        } catch (error) {
            console.error('There was an error clearing the fields!', error);
        }
    }, []);

    useEffect(() => {
        clearFields();
    }, [clearFields]);

    const handleUpdateClick = (id, e) => {
        setFormData({ ...formData, id: id });
        handleSubmit(e);
    };

    const handleCreateClick = () => {
        setFormData({ ...formData, id: '' });
    };

    const handleUpdateForNonLoggedinFeedBackUser = async (demoId, e) => {
        e.preventDefault();

        try {
            // Clone the current orchestration array
            const updatedOrchestration = formData.orchestration.map(feature => {
                return {
                    ...feature,
                    feedbacks: feature.feedbacks.map(feedback => {
                        return {
                            ...feedback,
                            //feedbackUser: { ...formData.demoUser } // Set demoUser as feedbackUser
                        };
                    })
                };
            });

            // Send the updated orchestration to the server
            const response = await axios.put(`${baseUrl}/demo/${demoId}/features/feedbacks`, updatedOrchestration, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.status === 200) {
                console.log("Feedbacks updated successfully");
            } else {
                console.error("Unexpected response status:", response.status);
            }
            showAlert();
        } catch (error) {
            console.error('Error updating feedbacks:', error);
        }
    };
  
// Utility function to get the target feature or sub-feature based on indexPath
const getFeatureByPath = (orchestration, indexPath) => {
  // Convert indexPath to a string first to safely use includes()
  const path = typeof indexPath === 'string' && indexPath.includes('-') 
    ? indexPath.split('-').map((i) => parseInt(i, 10)) 
    : [parseInt(indexPath, 10)];

  let targetFeature = orchestration[path[0]];

  // Traverse sub-features using the path for deeper nested features
  for (let i = 1; i < path.length; i++) {
    targetFeature = targetFeature.subFeatures[path[i]];
  }

  return targetFeature;
};

// Remove feedback for both main and sub-features
const removeFeedback = (featurePath, feedbackIndex) => {
  if (featurePath === null || featurePath === undefined || featurePath === '') {
    console.error("Invalid feature path:", featurePath);
    return;
  }


  setFormData((prevState) => {
    const updatedOrchestration = [...prevState.orchestration];

    // Get the target feature (main or sub-feature) by its path
    const targetFeature = getFeatureByPath(updatedOrchestration, featurePath);

    if (!targetFeature) {
      console.error("Feature not found for path:", featurePath);
      return prevState;
    }

    // Remove the feedback at the specified index
    const updatedFeedbacks = targetFeature.feedbacks.filter((_, j) => j !== feedbackIndex);

    // Update the feature with the new feedbacks array
    targetFeature.feedbacks = updatedFeedbacks;

    // Return the updated form data
    return { ...prevState, orchestration: updatedOrchestration };
  });
};


const addFeedback = (featurePath) => {
  if (featurePath === null || featurePath === undefined || featurePath === '') {
    console.error("Invalid feature path:", featurePath);
    return;
  }

  setFormData((prevState) => {
    const updatedOrchestration = [...prevState.orchestration];

    // Get the target feature (main or sub-feature) by its path
    const targetFeature = getFeatureByPath(updatedOrchestration, featurePath);

    if (!targetFeature) {
      console.error("Feature not found for path:", featurePath);
      return prevState;
    }

    // Create sets to collect unique checkboxes and questions
    const checkboxSet = new Set();
    const questionSet = new Map(); // Use a Map to store questions by their text
    const uniqueCheckboxes = [];
    const uniqueQuestions = [];

    // Helper function to collect checkboxes and questions from feedback
    const collectFeedbackData = (feedbacks) => {
      feedbacks?.forEach((feedback) => {
        // Collect unique checkboxes
        feedback.checkboxes?.forEach((checkbox) => {
          if (!checkboxSet.has(checkbox.label)) {
            uniqueCheckboxes.push({ ...checkbox });
            checkboxSet.add(checkbox.label);
          }
        });

        // Collect unique questions
        feedback.questions?.forEach((question) => {
          // Check if the question text already exists in the questionSet
          if (!questionSet.has(question.question)) {
            const questionId = question.id || uuidv4(); // Use existing ID if available, otherwise generate a new one
            const newQuestion = {
              ...question,
             id: questionId ,
            
             
            };
            uniqueQuestions.push(newQuestion);
            questionSet.set(question.question, newQuestion);
          }
        });
       
      });
    };

    // Collect data from the main feature's feedbacks
    collectFeedbackData(targetFeature.feedbacks);

    // Collect data from subFeatures if they exist
    const collectSubFeatures = (subFeatures) => {
      subFeatures.forEach((subFeature) => {
        collectFeedbackData(subFeature.feedbacks);
        if (subFeature.subFeatures && subFeature.subFeatures.length > 0) {
          collectSubFeatures(subFeature.subFeatures);
        }
      });
    };

    // If subFeatures exist, collect data from them as well
    if (targetFeature.subFeatures && targetFeature.subFeatures.length > 0) {
      collectSubFeatures(targetFeature.subFeatures);
    }

    // Create a new feedback object
    const newFeedback = {
      feedbackUser: {
        firstName: prevState.demoUser?.firstName || '',
        lastName: prevState.demoUser?.lastName || '',
        email: prevState.demoUser?.email || '',
        commonName: prevState.demoUser?.commonName || '',
        phone: prevState.demoUser?.phone || '',
        webSiteUrl: prevState.demoUser?.webSiteUrl || '',
        companyName: prevState.demoUser?.companyName || ''
      },
      impactsOnYourBusiness: [''],
      doesThisSolveTheProblem: false,
      doYouSeeYourSelfUsingIt: false,
      questions: uniqueQuestions.length > 0 ? uniqueQuestions : [
        {
          id: uuidv4(),
          question: '', 
          answer: '', 
          booleanAnswer: false, 
          bgColor: 'white', 
          textColor: 'white', 
          blockquote: '', 
          imageUrl: '',
          isNew:true
        }
      ],
      checkboxes: uniqueCheckboxes.length > 0 ? uniqueCheckboxes : [],
      isNew: true // Mark this feedback as newly added
    };

    // Add the new feedback to the feature's feedback array
    targetFeature.feedbacks = [...(targetFeature.feedbacks || []), newFeedback];

    return { ...prevState, orchestration: updatedOrchestration };
  });
};



const handleImageUrlChange = (indexPath, urlIndex, value) => {
  setFormData((prevState) => {
    const updatedOrchestration = [...prevState.orchestration];
    const targetFeature = getFeatureByPath(updatedOrchestration, indexPath); // Use utility function to get feature or sub-feature

    if (targetFeature.imageType === 'carousel') {
      const updatedImageUrls = [...targetFeature.imageUrls];
      updatedImageUrls[urlIndex] = value;
      targetFeature.imageUrls = updatedImageUrls;
    } else {
      targetFeature.imageUrl = value;
    }

    return { ...prevState, orchestration: updatedOrchestration };
  });
};


const handleAddImageUrl = (indexPath) => {
  setFormData((prevState) => {
    const updatedOrchestration = [...prevState.orchestration];
    const targetFeature = getFeatureByPath(updatedOrchestration, indexPath); // Use utility function to get feature or sub-feature

    if (targetFeature.imageType === 'carousel') {
      targetFeature.imageUrls = [...targetFeature.imageUrls, ""];
    } else {
      targetFeature.imageUrl = ""; // Optional for non-carousel types
    }

    return { ...prevState, orchestration: updatedOrchestration };
  });
};


// Function to remove a URL field from carousel images for both features and sub-features
const handleRemoveImageUrl = (indexPath, urlIndex) => {
  setFormData((prevState) => {
    const updatedOrchestration = [...prevState.orchestration];
    const targetFeature = getFeatureByPath(updatedOrchestration, indexPath);

    if (targetFeature.imageType === 'carousel') {
      const updatedImageUrls = targetFeature.imageUrls.filter((_, j) => j !== urlIndex);
      targetFeature.imageUrls = updatedImageUrls;
    }

    return { ...prevState, orchestration: updatedOrchestration };
  });
};

  //reseting setSelectedFeature is very important other wise it will rerender forever

  const handleImageUpload = (imageUrl) => {
    setFormData(prevState => ({
      ...prevState,
      demoUser: {
        ...prevState.demoUser,
        imageUrl
      }
    }));
  };


    return (
        <MDBContainer breakpoint="lg" className="text-center align-items-center " >
            {tokenLoaded &&   <MDBRow className= 'gx-lg-5 d-flex justify-content-center mb-2 mt-2'>
                <MDBCol md='5'>
                    
                        <DemoSearch setFormData={setFormData} refreshCompanyList={refreshCompanyList} setInitialName={setInitialName}/>
                 
                </MDBCol>
                <MDBCol md='3'>
                    <MDBBtn  color='info' onClick={() => setIsEdit(!isEdit)}>
                        {isEdit ? 'View Mode' : 'Edit Mode'}
                    </MDBBtn>
                </MDBCol>
            </MDBRow>}

            <form id={formData.id} onSubmit={(e) => {
    e.preventDefault();  // Prevent default form submission on unintended buttons
   
    handleSubmit(e);  // Only call handleSubmit for the actual form submission
  }} className="align-items-center justify-content-center">
    <div className='position-relative'>
{isEdit ? (
  <MDBCard className='mb-2 ms-2 me-2'>
    <MDBCardHeader className="fs-1 text-center">Intro</MDBCardHeader>
    <MDBRow className="text-center align-items-center justify-content-center">
      <MDBCol> <img
        className="rounded-circle shadow-1 mb-3 "
        src={formData.demoUser.imageUrl || "https://opengrit.com/images/745df300-d7a9-4256-9ab0-0da784c6d527"}
        alt="avatar"
        style={{ width: "150px" }}
        />
      </MDBCol>
      <MDBCol>      <Upload documentType={'image'} onImageUpload={handleImageUpload} /></MDBCol>
   
  
    </MDBRow>

    <MDBCardBody>
      {/* Main Messages */}
      {(formData.mainMessages || []).map((item, index) => (
        <div key={index} className='d-flex align-items-center mb-2' style={{ gap: '10px', width: '100%' }}>
          <MDBTextArea
            className="mt-2 flex-grow-1 mb-2"
            id={`mainMessage-${index}`}
            label={`Main Message ${index + 1}`}
            rows={2}
            value={item}
            onChange={(e) =>
              setFormData((prevState) => ({
                ...prevState,
                mainMessages: [
                  ...prevState.mainMessages.slice(0, index),
                  e.target.value,
                  ...prevState.mainMessages.slice(index + 1)
                ]
              }))
            }
          />
          <MDBBtn
            tag='a'
            color='none'
            type='button'
            onClick={() => removeMainMessage(index)}
            style={{ color: '#dd4b39' }}
          >
            <MDBIcon fas icon="times" />
          </MDBBtn>
        </div>
      ))}

      <MDBBtn
        className='mb-2 mx-5 mt-2'
        color='primary'
        onClick={addMainMessage}
        type='button'
      >
        Add Main Message
      </MDBBtn>

      {/* Company Name */}
      <MDBInput
        className="mt-2 flex-grow-1 mb-2"
        id='companyNameFormMain3'
        label='Name*'
        name='companyName'
        required
        value={formData.demoUser?.companyName || ''}
        onChange={(e) => handleDemoUserChange(e.target.name, e.target.value)}
      />
       <MDBInput
            wrapperClass='mb-2'
            id='form6Example7'
            label='Avatar'
            name='imageUrl'
            value={formData.demoUser?.imageUrl || 'https://opengrit.com/images/avatar'}
            onChange={(e) => handleDemoUserChange(e.target.name, e.target.value)}
          />
    </MDBCardBody>
  </MDBCard>
) : formData.demoUser ? (
  <MDBRow className='align-items-center justify-content-center'>
    <MDBCol sm='10'>
      <div>
        <div className="card-body text-center">
          <img
            className="rounded-circle shadow-1 mb-3"
            src={formData?.demoUser?.imageUrl || 'https://opengrit.com/images/avatar'}
            alt="avatar"
            style={{ width: "150px" }}
          />
          {console.log("Image URL:", formData.demoUser.imageUrl)} {/* Debugging line */}
          {(!tokenLoaded || !isEdit) && formData.mainMessages && formData.mainMessages.length > 0 && (
            <>
              {formData.mainMessages.map((msg, msgIndex) => (
                <p key={`mainMsg-${msgIndex}`}>
                  {msg}
                </p>
              ))}
            </>
          )}
        </div>
      </div>
    </MDBCol>
  </MDBRow>
) : null}
{((formData?.familyPictures?.length || 0) !== 0 || isEdit ) && <MDBBtn
          color="link" style={{ color: showCarousel ? '#dd4b39' :  '#3b5998' }}
          onClick={() => setShowCarousel(!showCarousel)} 
           type="button" 
         className="position-absolute top-0 end-0 translate-middle m-1"
        >
          {showCarousel ? <MDBIcon fas icon="eye" /> : <MDBIcon fas icon="eye-slash" />}
        </MDBBtn> }

        </div>


      <MDBModal open={isOpen} onClose={() => setIsOpen(false)} tabIndex='-1' className="bg-transparent border-0 "  onClick={(e) => e.preventDefault()} nonInvasive >
        <MDBModalDialog centered className="bg-transparent border-0" >
          <MDBModalContent className="border-0">
          
            <MDBModalBody className=" border-0"><MDBIcon fas icon="check-circle" size='8x'/></MDBModalBody>

         
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal open={showCarousel} onClose={() => setShowCarousel(false)} tabIndex='-1' className="bg-transparent border-0">
  <MDBModalDialog centered className="bg-transparent border-0" >
    <MDBModalContent className="bg-transparent border-0">   
      <div className='mb-2 mt-2'>
        <div>
          <div className='d-flex flex-column flex-grow-1 ' style={{ gap: '10px', width: '100%' }}>
            {isEdit && (
              <div className="d-flex flex-column flex-grow-1">
                <MDBInput
                  label="Add Family Picture URL"
                  value={newUrl}
                  onChange={(e) => setNewUrl(e.target.value)}
                  className="mb-2"
                />
                <MDBInput
                  label="Add Caption"
                  value={newCaption}
                  onChange={(e) => setNewCaption(e.target.value)}
                  className="mb-2"
                />
              </div>
            )}

            {isEdit && (
              <MDBBtn
                color="primary"
                onClick={addFamilyPicture}
                disabled={!newUrl || !newCaption}
                type='button'
                className="mb-2"
              >
                Add Pictures
              </MDBBtn>
            )}
          </div>

          {/* Conditionally render carousel if there are images */}
          {showCarousel && (formData.familyPictures || []).length > 0 && (
            <div className="d-flex justify-content-center">
              <MDBCarousel showIndicators showControls keyboard fade className='mb-3 d-flex' style={{ height: '400px', width: '100%' }}>
                {(formData.familyPictures || []).map((picture, index) => (
                  <MDBCarouselItem itemId={index + 1} key={index}>
                    <img 
                      src={picture.url} 
                      className="d-block rounded-5 mx-auto"  // Ensure the image is always centered
                      alt={`family-pic-${index}`} 
                      style={{ height: '400px', width: 'auto' }} // Ensure consistent sizing
                    />
                    <MDBCarouselCaption>
                      <h5>{picture.caption}</h5>
                      {tokenLoaded && (
                        <MDBBtn
                        color="link"                          
                          onClick={() => removeFamilyPicture(index)}
                          style={{ position: 'absolute', top: '10px', right: '10px' , color: '#dd4b39'}}
                        >
                            <MDBIcon fas icon="times" size="sm" />
                        </MDBBtn>
                      )}
                    </MDBCarouselCaption>
                  </MDBCarouselItem>
                ))}
              </MDBCarousel>
            </div>
          )}

          {/* List for editing URL and Caption */}
          <div className='align-items-center'>
            {Array.isArray(formData?.familyPictures) && formData.familyPictures.length > 0 && formData.familyPictures.map((picture, index) => (
              isEdit && (
                <MDBBtnGroup key={index} className='d-flex align-items-center  mb-2 ' >
                  <MDBInput
                    className="flex-grow-1 mb-2"
                    label={`Image URL ${index + 1}`}
                    value={picture.url}
                    onChange={(e) => handlePictureChange(index, 'url', e.target.value)}
                  />
                  <MDBInput
                    className="flex-grow-1 mb-2"
                    label={`Caption ${index + 1}`}
                    value={picture.caption}
                    onChange={(e) => handlePictureChange(index, 'caption', e.target.value)}
                  />
                  <MDBBtn
                    tag='a'
                    color='none'
                    type='button'
                    onClick={() => removeFamilyPicture(index)}
                    style={{ color: '#dd4b39', minWidth: '40px', padding: '8px' }}
                  >
                    <MDBIcon fas icon="times" />
                  </MDBBtn>
                </MDBBtnGroup>
              )
            ))}
          </div>
        </div>
      </div>
    </MDBModalContent>
  </MDBModalDialog>
</MDBModal>

<div className='text-center ms-2 me-2'>
                    {formData.demoUser && <MDBCardHeader className="fs-1 text-center">{formData.demoUser?.companyName}</MDBCardHeader>}
                    
                    
                    
                    <div>
                    {(tokenLoaded && isEdit)?  <FieldGroup
                            fields={['prep', 'check', 'agenda']}
                            formData={formData}
                            isEdit={isEdit}
                            handleChange={handleChange}
                            addItem={addItem}
                            removeItem={removeItem}
                        /> :
                        (formData['prep'] || formData['check'] || formData['agenda']) && tokenLoaded &&
                        <FieldGroup
                            fields={['prep', 'check', 'agenda']}
                            formData={formData}
                            isEdit={isEdit}
                            handleChange={handleChange}
                            addItem={addItem}
                            removeItem={removeItem}
                        />
                        }
  <div className='text-center ms-2 me-2 '>
  <MDBCardHeader> {(tokenLoaded && isEdit) ? 
                      <MDBInput
                      id='orchestration_input_Name'
                      label='MainHeading'
                      className='mb- mt-2'
                      value={formData.name} // Make sure this points to the correct state variable
                      onChange={(e) => handleChange(null, null, null, 'name', e.target.value)}
                  />
                  
                       
                        :
                        <h3>{formData?.name || 'Orchestrate Feature Ask Flow'}</h3> }</MDBCardHeader>
   <div>
     

    <div className='text-center align-items-center justify-content-center'>
      
    <FeatureList 
    formData={formData}
         demoId={formData.id}
         setCentredModal={setCentredModal}
         centredModal={centredModal}
         selectedFeature={selectedFeature}
       setSelectedFeature={setSelectedFeature}
       handleCloseModal={handleCloseModal}
         isEdit={isEdit}
         handleChange={handleChange}
         handleAddImageUrl={handleAddImageUrl}
         handleRemoveImageUrl={handleRemoveImageUrl}
         handleImageUrlChange={handleImageUrlChange}
         handlePainPromiseChange={handlePainPromiseChange}
         addPainPromise={addPainPromise}
         removePainPromise={removePainPromise}
         handleUpdateForNonLoggedinFeedBackUser={handleUpdateForNonLoggedinFeedBackUser}
         addFeedback ={addFeedback}
         removeImpact={removeImpact}
         addImpact={addImpact}
         activeAccordions={activeAccordions}
         setActiveAccordions={setActiveAccordions}
       setFormData={setFormData}
         demoUser={formData.demoUser}
         handleCheckboxChange={handleCheckboxChange}
         addCheckbox={addCheckbox}
         removeCheckbox={removeCheckbox}
         handleCheckboxLabelChange={handleCheckboxLabelChange}
         addQuestion={addQuestion}
         removeQuestion={removeQuestion}
         handleQuestionInputChange={handleQuestionInputChange}
         handleAnswerInputChange={handleAnswerInputChange}
         handleFeedbackUserChange={handleFeedbackUserChange}
         removeFeedback={removeFeedback}
         addFeature={addFeature}
         removeFeature={removeFeature}
         addSubFeature={addSubFeature}
  removeSubFeature={removeSubFeature}
  activeFeatureIndex = {activeFeatureIndex}
   setActiveFeatureIndex={setActiveFeatureIndex}
      />
     

      {(isEdit && tokenLoaded) && (
        <div className='position-relative mt-2'>
         <MDBBtn  tag='a' color='dark' floating
            className='position-absolute  end-0 mb-2 me-2 bottom-0'
           
            onClick={(e) => {
              e.preventDefault(); // Prevent form submission
              addFeature();
            }}
          >
            <MDBTooltip tag='a' wrapperProps={{ href: '#' }} title='Add Feature'>
            <MDBIcon fas icon="plus" color='light'/>
            </MDBTooltip>
          </MDBBtn>
        </div>
      )}
         
 
    </div>


      {/* Add Feature Button */}
      {(isEdit && tokenLoaded) && (
        <div className='position-relative mt-2'>
         <MDBBtn  tag='a' color='dark' floating
            className='position-absolute  end-0 mb-2 me-2 bottom-0'
           
            onClick={(e) => {
              e.preventDefault(); // Prevent form submission
              addFeature();
            }}
          >
            <MDBTooltip tag='a' wrapperProps={{ href: '#' }} title='Add Feature'>
            <MDBIcon fas icon="plus" color='light'/>
            </MDBTooltip>
          </MDBBtn>
        </div>
      )}
         
 
    </div> 
  </div>
 {(tokenLoaded && isEdit)? <div>
                            <h1 className="text-warning"> Next </h1>
                            <hr className="hr text-warning" />
                        <FieldGroup
                            fields={['review', 'close', 'followUp']}
                            formData={formData}
                            isEdit={isEdit}
                            handleChange={handleChange}
                            addItem={addItem}
                            removeItem={removeItem}
                        />
</div> :
  (formData['review'] || formData['close'] || formData['followUp']) && tokenLoaded && <div>
                            <h1 className="text-warning"> Next </h1>
                            <hr className="hr text-warning" />
                        <FieldGroup
                            fields={['review', 'close', 'followUp']}
                            formData={formData}
                            isEdit={isEdit}
                            handleChange={handleChange}
                            addItem={addItem}
                            removeItem={removeItem}
                        />
</div>
}
</div>
</div>
  {(isEdit && tokenLoaded) && (
    <MDBBtnGroup>
       {/* Conditionally render the Create button if the name has changed */}
       {formData.demoUser?.companyName !== initialName ?
                <MDBBtn color='warning' onClick={handleCreateClick}>
                    Create
                </MDBBtn> :
      <MDBBtn type='button' onClick={(e) => {handleUpdateClick(formData.id, e);handleCloseModal()}}>
      Update
    </MDBBtn>
            }
      <MDBBtn color='danger' type='button' onClick={handleDelete}>
        Delete
      </MDBBtn>

      <MDBBtn color='success' type='button' onClick={clearFields}>
        Clear Data
      </MDBBtn>
    </MDBBtnGroup>
  ) }
</form>

        </MDBContainer>
    );
};

export default Builder;
